export default {
  services_number_title: "Número de servicios para elegir",
  additional_information_after_booking_title:
    "Información adicional en el correo electrónico después de la reserva",
  additional_information_after_booking_subtitle:
    "Información adicional que se enviará en los correos electrónicos relacionados con las reservas de servicios (creación, modificación y recordatorios sobre la reserva). Si has editado las notificaciones, asegúrate de que la variable correspondiente esté configurada en el contenido: [ADDITIONAL_INFORMATION_AFTER_BOOKING].",
  additional_information_after_booking_dummy_text:
    "Este es un texto de ejemplo que será reemplazado por información adicional después de la reserva, si dicha información ha sido proporcionada en la configuración del servicio.",
  plugins_storage_100gb_cd_base_pro_name: "Almacenamiento 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "Almacenamiento 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "Más espacio para archivos. Obtén 100 GB adicionales para compartir archivos con clientes y recibir adjuntos a través de formularios de reserva. Una solución ideal para optimizar la comunicación y mejorar la atención al cliente.",
  plugins_storage_500gb_cd_base_pro_description:
    "Espacio máximo para tus archivos. Usa 500 GB de almacenamiento para intercambiar archivos con clientes y recibir adjuntos a través de formularios de reserva sin limitaciones. Esencial para empresas en rápido crecimiento que valoran el profesionalismo y la comodidad.",
  bookings_this_month: "Reservas este mes",
  bookings_all_processed: "Todas las reservas",
  simple_store_product_transactions_this_month: "Productos vendidos este mes",
  files_storage_usage: "Almacenamiento usado",
  files_storage_usage_from_available_prefix: "de los disponibles",
  not_available_in_standard_plan: "Función no disponible en el plan Standard",
  cancel_reason_dropdown_label: "Motivo de cancelación de la suscripción",
  cancel_subscription_category_1_title: "Problemas técnicos",
  cancel_subscription_category_1_reason_1_title:
    "Caídas frecuentes o interrupciones",
  cancel_subscription_category_1_reason_2_title:
    "Rendimiento lento del sistema",
  cancel_subscription_category_1_reason_3_title: "Interfaz difícil de usar",
  cancel_subscription_category_1_reason_4_title:
    "Problemas con las integraciones (por ejemplo, sistema de pagos, calendarios externos)",
  cancel_subscription_category_1_reason_5_title:
    "Preocupaciones de seguridad (por ejemplo, filtraciones de datos)",
  cancel_subscription_category_1_reason_6_title:
    "Problemas con la aplicación móvil del empleado (por ejemplo, bloqueos, errores)",
  cancel_subscription_category_2_title: "Cambios personales o empresariales",
  cancel_subscription_category_2_reason_1_title:
    "Cambio en el modelo de negocio (por ejemplo, menor necesidad de reservas)",
  cancel_subscription_category_2_reason_2_title:
    "Restricciones presupuestarias o dificultades financieras",
  cancel_subscription_category_2_reason_3_title:
    "Demasiada carga de trabajo para gestionar el sistema",
  cancel_subscription_category_2_reason_4_title:
    "Cierre o reducción del negocio",
  cancel_subscription_category_2_reason_5_title:
    "Falta de tiempo para gestionar las reservas",
  cancel_subscription_category_3_title: "Precio y competencia",
  cancel_subscription_category_3_reason_1_title:
    "Existen alternativas más baratas",
  cancel_subscription_category_3_reason_2_title:
    "Aumento de precio o cambio en el modelo de facturación",
  cancel_subscription_category_4_title: "Problemas de experiencia de usuario",
  cancel_subscription_category_4_reason_1_title:
    "Dificultad para navegar en el sistema",
  cancel_subscription_category_4_reason_2_title: "Faltan funciones esenciales",
  cancel_subscription_category_4_reason_3_title:
    "Demasiado complejo para mi equipo o negocio",
  cancel_subscription_category_4_reason_4_title:
    "Atención al cliente lenta o poco útil",
  cancel_subscription_category_4_reason_5_title:
    "Opciones de personalización limitadas",
  cancel_subscription_category_4_reason_6_title:
    "Proceso de configuración o implementación complicado",
  cancel_subscription_category_5_title: "Factores externos y del mercado",
  cancel_subscription_category_5_reason_1_title:
    "Cambio en las tendencias del mercado (por ejemplo, transición a reservas por redes sociales)",
  cancel_subscription_category_5_reason_2_title:
    "Crisis económica o desaceleración",
  cancel_subscription_category_5_reason_3_title:
    "Cambios en la normativa legal",
  cancel_subscription_category_6_title: "Otros",
  cancel_subscription_category_6_reason_1_title: "Motivo no listado aquí",
  cancel_subscription_category_6_reason_2_title: "Prefiero no decirlo",
  cancel_plan_and_delete_data: "Cancelar y eliminar mis datos",
  cancel_plan_do_nothing: "No hacer nada",
  cancel_plan_and_keep_data_confirmation_label:
    "¿Estás seguro de que quieres cancelar tu suscripción pero conservar tus datos?",
  cancel_plan_and_keep_data_confirmation_info:
    "La suscripción se cancelará al final del período de facturación ya pagado. Los datos se almacenarán de forma segura en nuestros servidores y podrán restaurarse en cualquier momento al reactivar la suscripción.",
  scheduled_cancel_keeps_data_info:
    "Tu plan será cancelado, pero tus datos permanecerán almacenados",
  no_just_checking_title: "No, solo estoy comprobando",
  payment_deadline_before_start_variable:
    "Plazo de pago antes del inicio de cada reserva recurrente",
  send_payment_reminder_before_start_variable:
    "Tiempo de notificación de recordatorio de pago antes de la reserva",
  booking_awaiting_payment_full_description:
    "Información completa sobre el pago requerido",
  booking_awaiting_payment_full_description_example:
    "La reserva será cancelada si no se realiza el pago en 30 min. Haz clic a continuación para ir a tu reserva y realizar el pago.",
  recurring_meeting_in_the_past_warning:
    'No es posible crear una reunión recurrente con fechas de inicio en el pasado. Elige una fecha de inicio en el futuro o desmarca la opción "Este evento se repite".',
  // Booking overlaps dialog
  booking_overlaps_dialog_title: "Conflicto de calendario detectado",
  booking_overlaps_dialog_message:
    "Al verificar la disponibilidad, detectamos que el horario seleccionado está en conflicto con reservas existentes o fechas bloqueadas. Detalles del conflicto:",
  booking_overlaps_count: "Número de reservas en conflicto",
  unavailable_slot_overlaps_count: "Número de fechas bloqueadas en conflicto",
  booking_overlaps_dialog_question: "¿Quieres continuar de todos modos?",
  selected_date: "Fecha seleccionada",
  single_booking: "Reserva individual",
  external_api_service_not_enabled_error:
    "Lamentablemente, la función de la API no está disponible en esta cuenta.",
  service_not_available_at_selected_time:
    "El servicio no está disponible en el horario seleccionado.",
  offline_mode: "Estás desconectado",
  offline_description:
    "La aplicación requiere una conexión a internet para funcionar.",
  retry: "Reintentar",
  checking_connection: "Verificando conexión...",
  waiting_for_connection: "Esperando conexión",
  "2fa_verify_title": "Autenticación de dos factores",
  "2fa_verify_description":
    "Ingresa tu código de 6 dígitos de tu aplicación autenticadora o usa un código de recuperación:",
  "2fa_recovery_code_label": "Código de recuperación",
  "2fa_use_recovery_code": "Usar código de recuperación",
  "2fa_use_app_code": "Usar código de app",
  "2fa_verify_incorrect_error":
    "El código 2FA es incorrecto. Por favor, intenta de nuevo.",
  "2fa_session_expired_error":
    "Tu sesión 2FA ha expirado. Inicia sesión de nuevo.",
  "2fa_verification_cancelled":
    "La autenticación de dos factores fue cancelada. Inténtalo de nuevo.",
  enable_2fa: "Activar 2FA",
  enable_2fa_title: "Activar verificación en 2 pasos",
  disable_2fa: "Desactivar 2FA",
  disable_2fa_title: "Desactivar verificación en 2 pasos",
  "2fa_manual_setup": "¿No puedes escanear? Ingresa este código manualmente:",
  "2fa_recovery_codes_title": "Códigos de recuperación",
  "2fa_download_codes": "Descargar códigos",
  "2fa_disable_description":
    "Estás a punto de desactivar la verificación en 2 pasos. Esto hará tu cuenta menos segura.",
  "2fa_disable_warning":
    "Desactivar la verificación en 2 pasos reducirá la seguridad de tu cuenta.",
  "2fa_verify_to_disable": "Verificar tu identidad",
  "2fa_verify_to_disable_description":
    "Ingresa un código de tu app autenticadora o usa un código de recuperación para desactivar la verificación en 2 pasos.",
  warning: "Advertencia",
  current_password: "Contraseña actual",
  incorrect_password: "Contraseña incorrecta. Por favor, inténtalo de nuevo.",
  "2fa_setup_failed": "Error al configurar 2FA",
  "2fa_activation_failed": "Error al activar 2FA",
  "2fa_verification_code": "Código de verificación",
  "2fa_disabled_success": "2FA se ha desactivado correctamente",
  "2fa_disable_failed": "Error al desactivar 2FA",
  "2fa_step_1_password_title": "Ingresa tu contraseña",
  "2fa_step_1_scan_title": "Escanear código QR",
  "2fa_step_2_verify_title": "Verificar configuración",
  "2fa_authenticator_apps_required": "Se requiere app autenticadora",
  "2fa_setup_secure_subtitle":
    "Elige e instala una app 2FA segura para proteger tu cuenta",
  "2fa_apps_installation_note":
    "Instala una de estas apps en tu teléfono antes de continuar con la configuración.",
  "2fa_scan_with_app": "Escanea este código QR con tu app autenticadora",
  "2fa_enter_code_from_app":
    "Introduce el código de 6 dígitos de tu app autenticadora",
  "2fa_recovery_codes_warning":
    "Guarda estos códigos en un lugar seguro. Cada código solo puede usarse una vez.",
  "2fa_enter_password_to_continue":
    "Introduce tu contraseña actual para generar tu código QR único",
  "2fa_enter_password_to_disable":
    "Introduce tu contraseña actual para confirmar la desactivación de 2FA",
  "2fa_disable_verification_description":
    "Introduce tu contraseña actual y un código de tu aplicación autenticadora o usa un código de recuperación para desactivar la verificación en 2 pasos.",
  "2fa_recovery_codes_description":
    "Estos códigos de respaldo te permiten acceder a tu cuenta si pierdes tu aplicación autenticadora. Cada código solo puede usarse una vez, guárdalos en un lugar seguro.",
  security_settings: "Configuración de seguridad",
  security_settings_description:
    "Gestiona la configuración de seguridad de tu cuenta y los métodos de autenticación.",
  "2fa_security_title": "Verificación en 2 pasos",
  "2fa_security_description":
    "Añade una capa extra de seguridad a tu cuenta con la verificación en 2 pasos.",
  reset_password_description:
    "Envía un enlace de restablecimiento de contraseña a tu dirección de correo electrónico.",
  "2fa_enabled_success": "2FA se ha activado correctamente",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input: "Enlace a un perfil de LinkedIn",
  logs_diff_linkedin: "Enlace a un perfil de LinkedIn",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input: "Enlace a un perfil de TikTok",
  logs_diff_tiktok: "Enlace a un perfil de TikTok",
  wb_linkedin: "URL de LinkedIn",
  wb_tiktok: "URL de TikTok",
};
